<script setup>

import SideBannerMain from "@/components/SideBannerMain.vue";
</script>

<template>
  <div class="h-full w-full">
    <div class="block h-full w-full relative bg-[url('bgpattern.webp')] bg-repeat opacity-20">

    </div>
    <SideBannerMain/>
  </div>
</template>
